export default "__VITE_ASSET__CLiL62dk__"